<mat-nav-list>
  <a
    data-testid="nav-customer-dashboard"
    mat-list-item
    [routerLink]="
      needsCustomerIdInUrl()
        ? [Paths.CYBERSECURITY_COCKPIT_PATH, currentCustomerId(), Paths.DASHBOARD_PATH]
        : [Paths.CYBERSECURITY_COCKPIT_PATH, Paths.DASHBOARD_PATH]
    "
    routerLinkActive
    #dashboardRla="routerLinkActive"
    [activated]="dashboardRla.isActive || isUrlActive([Paths.CYBERSECURITY_COCKPIT_PATH, Paths.DASHBOARD_PATH], true)"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.dashboard' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="dashboard" />
    <span>{{ 'navbar.dashboard' | translate }}</span>
  </a>
  @if (showConfigurations()) {
    <a
      data-testid="nav-customer-module-configurations"
      mat-list-item
      [routerLink]="
        needsCustomerIdInUrl()
          ? [Paths.CYBERSECURITY_COCKPIT_PATH, currentCustomerId(), Paths.MODULE_CONFIGURATIONS_PATH]
          : [Paths.CYBERSECURITY_COCKPIT_PATH, Paths.MODULE_CONFIGURATIONS_PATH]
      "
      routerLinkActive
      #moduleConfigsRla="routerLinkActive"
      [activated]="
        moduleConfigsRla.isActive ||
        isUrlActive([Paths.CYBERSECURITY_COCKPIT_PATH, Paths.MODULE_CONFIGURATIONS_PATH], true)
      "
      [routerLinkActiveOptions]="{ exact: false }"
      [matTooltip]="'navbar.moduleConfigurations' | translate"
      [matTooltipDisabled]="!isCollapsed"
      matTooltipPosition="right"
    >
      <mat-icon class="icon" fontIcon="widgets" />
      <span>{{ 'navbar.moduleConfigurations' | translate }}</span>
    </a>
  }
  <a
    data-testid="nav-customer-test-runs"
    mat-list-item
    [routerLink]="
      needsCustomerIdInUrl()
        ? [Paths.CYBERSECURITY_COCKPIT_PATH, currentCustomerId(), Paths.TEST_RUNS_PATH]
        : [Paths.CYBERSECURITY_COCKPIT_PATH, Paths.TEST_RUNS_PATH]
    "
    routerLinkActive
    #testRunsRla="routerLinkActive"
    [activated]="testRunsRla.isActive || isUrlActive([Paths.CYBERSECURITY_COCKPIT_PATH, Paths.TEST_RUNS_PATH], true)"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.testRuns' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon material-symbols-outlined" fontIcon="calendar_clock" />
    <span>{{ 'navbar.testRuns' | translate }}</span>
  </a>

  <a
    data-testid="nav-customer-boxes"
    mat-list-item
    [routerLink]="
      needsCustomerIdInUrl()
        ? [Paths.CYBERSECURITY_COCKPIT_PATH, currentCustomerId(), Paths.BOXES_PATH]
        : [Paths.CYBERSECURITY_COCKPIT_PATH, Paths.BOXES_PATH]
    "
    routerLinkActive
    #boxesRla="routerLinkActive"
    [activated]="boxesRla.isActive || isUrlActive([Paths.CYBERSECURITY_COCKPIT_PATH, Paths.BOXES_PATH], true)"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.boxes' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="router" />
    <span>{{ 'navbar.boxes' | translate }}</span>
  </a>
  <a
    data-testid="nav-customer-users"
    mat-list-item
    [routerLink]="
      needsCustomerIdInUrl()
        ? [Paths.CYBERSECURITY_COCKPIT_PATH, currentCustomerId(), Paths.USERS_PATH]
        : [Paths.CYBERSECURITY_COCKPIT_PATH, Paths.USERS_PATH]
    "
    routerLinkActive
    #usersRla="routerLinkActive"
    [activated]="usersRla.isActive || isUrlActive([Paths.CYBERSECURITY_COCKPIT_PATH, Paths.USERS_PATH], true)"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.users' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="groups" />
    <span>{{ 'navbar.users' | translate }}</span>
  </a>
  <a
    data-testid="nav-customer-settings"
    mat-list-item
    [routerLink]="
      needsCustomerIdInUrl()
        ? [Paths.CYBERSECURITY_COCKPIT_PATH, currentCustomerId(), Paths.SETTINGS_PATH]
        : [Paths.CYBERSECURITY_COCKPIT_PATH, Paths.SETTINGS_PATH]
    "
    routerLinkActive
    #settingsRla="routerLinkActive"
    [activated]="settingsRla.isActive || isUrlActive([Paths.CYBERSECURITY_COCKPIT_PATH, Paths.SETTINGS_PATH], true)"
    [routerLinkActiveOptions]="{ exact: false }"
    [matTooltip]="'navbar.settings' | translate"
    [matTooltipDisabled]="!isCollapsed"
    matTooltipPosition="right"
  >
    <mat-icon class="icon" fontIcon="settings" />
    <span>{{ 'navbar.settings' | translate }}</span>
  </a>
</mat-nav-list>
